import { render } from "./VCalendarUi.vue?vue&type=template&id=74014fa9"
import script from "./VCalendarUi.vue?vue&type=script&lang=js"
export * from "./VCalendarUi.vue?vue&type=script&lang=js"

import "./VCalendarUi.vue?vue&type=style&index=0&id=74014fa9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__